import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  emailRegex,
  passwordRegex,
  ROUTES,
} from '../../../assets/constants/strings';
import { logIn, resendEmail } from '../../../store/User/userActions';
import { LOG_IN } from '../../../store/User/userTypes';
import AuthLoader from '../../Loader/Auth';
import RegCityLogo from '../RegCityLogo';

const Login = ({ user, logIn, loading, resendEmail }) => {
  const [email, setEmail] = useState('');

  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);

  const [invalidData, setInvalidData] = useState(false);
  const [loginError, setLoginError] = useState(null);

  const handleLogin = (e) => {
    e.preventDefault();
    if (!emailRegex(email) || !passwordRegex(password)) {
      setInvalidData(true);
    } else {
      setInvalidData(false);
      logIn(email, password);
    }
  };

  useEffect(() => {
    if (user && user.success === false && user.request === LOG_IN) {
      setLoginError(user.reason);
    } else setLoginError(null);
  }, [user]);

  return (
    <div className='pb-0'>
      <div className='d-flex flex-row align-items-center'>
        <RegCityLogo smallerLogo={true} />
      </div>
      <form onSubmit={handleLogin} className='my-3' autoComplete='off'>
        <div className='form-group mb-3'>
          <input
            className={`form-control${
              loginError && !loading ? ' is-invalid' : ''
            }`}
            placeholder='Email'
            type='email'
            id='Email'
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            required
          />
          {!invalidData &&
            loginError &&
            !loading &&
            email &&
            email.length > 0 &&
            password &&
            password.length > 0 && (
              <React.Fragment>
                {loginError.includes('Cannot read properties ') ||
                loginError.includes(' undefined ') ||
                loginError.includes('undefined is not an object ') ||
                loginError.includes('undefined ') ||
                loginError.includes(' subs ') ? (
                  <label id='EmailError' className='text-danger mt-1 mb-0'>
                    * Please review your email and password
                  </label>
                ) : (
                  <label id='EmailError' className='text-danger mt-1 mb-0'>
                    {loginError}
                  </label>
                )}
                {loginError.match('Account Not Confirmed') && (
                  <p className='mt-2'>
                    Did not receive Confirmation? Click{' '}
                    <span
                      className='inner-link font-weight-bold'
                      onClick={() => resendEmail(user.userID, email)}
                    >
                      here
                    </span>{' '}
                    to get a new link.
                  </p>
                )}
              </React.Fragment>
            )}
        </div>
        <div className='form-group mb-3 position-relative'>
          <input
            className={`form-control${
              !loading && invalidData ? ' is-invalid' : ''
            }`}
            placeholder='Password'
            type={showPass ? 'text' : 'password'}
            id='Password'
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            required
          />
          {password.length > 0 ? (
            showPass ? (
              <FaEyeSlash
                className={`password-visibility${
                  invalidData && !loading ? '' : ' no-validate'
                }`}
                title='Hide Password'
                onClick={() => setShowPass(false)}
              />
            ) : (
              <FaEye
                className={`password-visibility${
                  invalidData && !loading ? '' : ' no-validate'
                }`}
                title='Show Password'
                onClick={() => setShowPass(true)}
              />
            )
          ) : null}
          {invalidData && !loading && (
            <label id='EmailError' className='text-danger mt-1 mb-0'>
              * Please review your email and password
            </label>
          )}
        </div>
        <button type='submit'>Log In{loading ? <AuthLoader /> : null}</button>
      </form>
      <div className='wf-account__card__reset'>
        <Link to={ROUTES.FORGOT}>Lost your password?</Link>
      </div>
      <div className='wf-account__card__reset mt-4'>
        <Link to={ROUTES.SIGNUP}>
          Don't have an account? <b>Register Now</b>
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  loading: state.user.loading,
});

const mapDispatchToProps = { logIn, resendEmail };

export default connect(mapStateToProps, mapDispatchToProps)(Login);
